export default "__VITE_PUBLIC_ASSET__e5725156__"